import React, { useEffect, useState, Fragment, useRef } from "react";
import { ReportTableContent } from '../../../Common/Table/tableContent';

export default class ComponentToPrint extends React.Component {
    render() {
        const data = this.props.data;
        const searchData = this.props.searchData;
        const contentRowNames = this.props.contentRowNames;
        const  initialData=this.props.initialData;

        return (
            <div className="p-2">
                <h3><center><u>Half Name Mark Report Report</u></center></h3>
                <div className="row pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Operation Entity: </b> {searchData.operationEntity}</div>
                    <div className="col"><b>Collection Point: </b> {searchData.collectionPoint}</div>
                </div>
                <div className="table-responsive row-top-gap">
                    <table className="display dataTable no-footer">
                        <thead>
                            <tr>
                            <th style={{ textAlign: "center" }}>Employee Name</th>
                            <th style={{ textAlign: "center" }}>Registration Number</th>
                            <th style={{ textAlign: "center" }}>Card Number</th>
                            <th style={{ textAlign: "center" }}>Total Weight (Kg)</th>
                            <th style={{ textAlign: "center" }}>Reason</th>
                            <th style={{ textAlign: "center" }}>Last Weigh Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ReportTableContent
                                data={data}
                                contentRowNames={contentRowNames}
                                hasEdit={false}
                            />
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}


